export default __webpack_public_path__ + "25f86942fa1a22a3136be9a7d354ad6b.webp";